import { API_ENDPOINTS } from 'App/constants'

export const submitPath = (userBpid): string => `${API_ENDPOINTS.DCDUrl}/${userBpid}/ds-quiz`
export const resultOutfitsPath = (userBpid): string =>
  `${API_ENDPOINTS.DCDUrl}/${userBpid}/ds-result-outfits`
export const resultCategoriesPath = (userBpid): string =>
  `${API_ENDPOINTS.DCDUrl}/${userBpid}/ds-result-categories`
export const getArticlesPath = (articleIds: string[] = []): string =>
  `pra/articles/v2/byids?id=${articleIds.join('&id=')}`

export const defaultBpIdForConfigs = '0000000'
export const quizConfigPath = `${API_ENDPOINTS.DCDUrl}/${defaultBpIdForConfigs}/ds-quiz-config`

const eventBaseType = 'DIGITAL_STYLIST'
/* eslint-disable @typescript-eslint/naming-convention */
const event_type = `${eventBaseType}_QUIZ`
const event_id = 'Digital stylist'
const event_category = 'Club'
/* eslint-enable @typescript-eslint/naming-convention */

export const DIGITAL_STYLIST_TRACKING_EVENTS = {
  intro: {
    event_type,
    event_id,
    event_category,
    event_label: 'Quiz intro',
  },
  begin: {
    event_type,
    event_id,
    event_category,
    event_label: 'Begin quiz',
  },
  flow: {
    event_type,
    event_id,
    event_category,
    event_label: 'Flow',
    quiz_percent: 0,
    quiz_page: '',
    quiz_version: '',
  },
  completed: {
    event_type,
    event_id,
    event_category,
    event_label: 'Completed quiz',
  },
  clickOnProduct: {
    event_type: `${eventBaseType}_CLICK`,
    product_list_name: [event_id],
    event_id,
    event_category,
  },
  productImpression: {
    event_type: `${eventBaseType}_VIEW`,
    event_id,
    event_category,
    imp_list_name: event_id,
  },
  goToQuiz: {
    category_id: 'CLUB',
    page_id: 'OFFER DETAILS',
    event_type,
    event_category: 'myAccount',
    event_id,
    event_label: 'Click on go to quiz',
  },
  editorial: {
    event_type,
    event_id,
    event_category,
    event_label: 'Editorial DS',
  },
}
